import { useQuery, gql } from "@apollo/client"

const useUsers = (variables = {}, options = {}) => {
    return useQuery(
        gql`
            query (
                $state: Boolean
                $sortField: String
                $previous: String
                $next: String
                $limit: Int
                $ids: [ID!]
                $roles: [Roles!]
                $search: String
            ) {
                allUsers (
                    state: $state
                    sortField: $sortField
                    previous: $previous
                    next: $next
                    limit: $limit
                    ids: $ids
                    roles: $roles
                    search: $search
                ) {
                    hasNext
                    hasPrevious
                    next
                    previous
                    totalDocs
                    docs {
                        id
                        firstName
                        lastName
                        roles
                        isCounselor
                    }
                }
            }
        `, 
        {
            fetchPolicy: 'no-cache',
            variables,
            ...options
        }
    )
}

export default useUsers